<template>
    <div class="wrapper-overlay open-overlay" v-if="isComponentLoaded">
        <div class="header-overlay header-overlay-svg">
            <img src="/ext_files/prepaid/f2g/images/logotype_dark.svg">
            <svg v-on:click="closeModal()" class="close-overlay" width="30px" height="30px" viewBox="0 0 30 30" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <desc>Created with Sketch.</desc>
                <g id="Icon/Menu/close" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <path
                        d="M4.38605846,25.6177075 C4.64303181,25.8725692 4.97774286,26 5.31247602,26 C5.6471926,26 5.98188707,25.8725692 6.23889359,25.6177075 L15,16.8528625 L23.7633218,25.6177075 C24.0202952,25.8725692 24.3528502,26 24.6897394,26 C25.024456,26 25.3591505,25.8725692 25.616157,25.6177075 C26.1279477,25.1058277 26.1279477,24.2764407 25.616157,23.7645498 L16.8528372,15.0019165 L25.6139457,6.23707158 C26.1257364,5.72519181 26.1257364,4.89580481 25.6139457,4.38391398 C25.102155,3.87202315 24.2729123,3.8720342 23.7611106,4.38391398 L15,13.1487589 L6.2366823,4.38612565 C5.7248916,3.87424587 4.89564893,3.87424587 4.38384717,4.38612565 C3.87204541,4.89800542 3.87205647,5.72739242 4.38384717,6.23928325 L13.1471669,15.0019165 L4.38605846,23.7667615 C3.87426776,24.2786413 3.87426776,25.1058719 4.38605846,25.6177627 L4.38605846,25.6177075 Z"
                        id="Path"
                        fill="#FFFFFF"
                        fill-rule="nonzero"
                    ></path>
                </g>
            </svg>
        </div>
        <div class="container-overlay overlay-form form-autotopup">
            <div>
                <div class="title-overlay1">
                    {{content["myf2g.topupautorecharge.title"]}}
                </div>
                <div class="title-overlay4">
                    {{content["myf2g.topupautorecharge.subtitle"]}}
                </div>
                <div class="form-overlay">

                    <template v-if="hasSavedCard">
                      <div class="box-payment-topup">
                          <img :src="savedCardIcon">
                          <div class="descr-payment">
                              {{savedCard.pan}}
                              <div class="smaller-text-descr">{{content["myf2g.topupautorecharge.message"]}} {{savedCardExpDate}}</div>
                          </div>
                          <a v-on:click="handleDeletePayment()" class="delete-payment">
                              <img src="/ext_files/prepaid/f2g/images/delete.svg" class="cursor-hand" />
                          </a>    
                      </div>

                      <div v-if="showDeletePaymentMessage" class="title-overlay3-left" v-on:click="deleteCard()">
                        {{content["myf2g.topupautorecharge.paragraph1"]}} <span class="font-red">{{content["myf2g.topupautorecharge.deletecard"]}}</span>.
                      </div>
                    </template>
                    


                      <div class="custom-select" :style="[areInputsDisabled ? disabledDropdownStyle : '']">
                          <select>
                              <option value="0">{{content["myf2g.topupautorecharge.label1"]}}</option>
                              <option v-for="i in 28" :value="i" :key="i">{{i}}</option>
                          </select>
                      </div>
                      <div class="input-amount-overlay">
                          <div class="form-field focused">
                              <label class="form-label" for="first">{{content["myf2g.topupautorecharge.label2"]}}</label>
                              <input :disabled="areInputsDisabled" :style="[areInputsDisabled ? disabledStyle : '']" type="text" class="overlay-input-text form-input" :class="[areInputsDisabled ? 'input-grey-color' : '']" v-model="amount" :placeholder="minTopUp + '-' + maxTopUp"/>
                          </div>
                      </div>

                    <template v-if="isAmountOutOfRange">
                      <span style="color:#FE4C6F; display:block; margin-top:-20px; margin-bottom:20px;">{{ amountOutOfRangeMessage }}</span>
                    </template>
                </div>
                <div>
                    <a v-on:click="handleCTA()">
                      <div class="container-button cursor-hand" :class="[areInputsValid ? 'blue-btn' : 'grey-btn']">
                          <template v-if="hasSavedCard && !areInputsDisabled">
                            {{content["myf2g.topupautorecharge.button3"]}}
                          </template>
                          <template v-else-if="hasSavedCard && areInputsDisabled">
                            {{content["myf2g.topupautorecharge.button1"]}}
                          </template>
                          <template v-else>
                            {{content["myf2g.topupautorecharge.button2"]}}
                          </template>                        
                      </div>
                    </a>
                </div>

                <div class="paragr-text cursor-hand" v-on:click="deleteRecurringPayment()" v-if="hasEnabledReccuring">
                    <a>{{content["myf2g.topupautorecharge.disableautorecharge"]}}</a>
                </div>

                <div class="title-overlay3">
                    {{content["myf2g.topupautorecharge.disclaimer"]}}
                </div>
            </div>
        </div>
    </div>
</template>



<script>
import $ from "jquery";

export default {
  name: "AutoRechargeModal",
  data() {
    return {
      isComponentLoaded: false,
      recurringDate: '',
      amount: '',
      showDeletePaymentMessage: false,
      content: '',
      isScheduleEditable: false,
      disabledDropdownStyle: {
        'pointer-events': 'none'
      },
      disabledStyle: {
        'color': 'grey'
      }
    }
  },
  computed: {
    locale() {
      return this.$store.state.locale;
    },
    areInputsValid() {
      return this.recurringDate != '' && this.amount != '' && !this.isAmountOutOfRange;
    },
    isAmountOutOfRange() {
      return (this.amount < this.minTopUp || this.amount > this.maxTopUp) && this.amount != '';
    },
    amountOutOfRangeMessage() {
      if (this.locale == 'en_US') {
        return 'The amount must be between € '+this.minTopUp+' and € '+this.maxTopUp+''
      } else {
        return 'Το ποσό πρέπει να είναι ανάμεσα από '+this.minTopUp+'€ ως και '+this.maxTopUp+'€'
      }
    },
    lang() {
      if (this.locale == "en_US") {
        return 'en';
      } else {
        return 'gr';
      }
    },
    language() {
      if (this.locale == "en_US") {
        return 'en';
      } else {
        return 'el';
      }
    },
    hasSavedCard(){
      return this.getCardAndRecurringInfoObject.cardList.length > 0;
    },
    savedCard() {
      if (this.hasSavedCard) {
        return this.getCardAndRecurringInfoObject.cardList[0]
      } else {
        return null;
      }
    },
    hasDatacacheReference() {
      if (this.savedCard) {
        if (typeof this.savedCard.datacacheReference != "undefined" && this.savedCard.datacacheReference != null) {
          return this.savedCard.datacacheReference;
        }
      } else {
        return null;
      }
    },
    savedCardExpDate() {
      if (this.hasSavedCard) {
        var dateMonthYearItems = this.savedCard.expiryDate.split('/');
	      return dateMonthYearItems[0]+"."+"20"+dateMonthYearItems[1];
      } else {
        return null;
      }
      
    },
    savedCardIcon() {
      if (this.hasSavedCard) {
        switch (this.savedCard.brand) {
          case 'mastercard' : return '/ext_files/prepaid/f2g/images/iconMastercard.png'; break
          case 'visa' : return '/ext_files/prepaid/f2g/images/iconVisa.png'; break
          case 'maestro' : return '/ext_files/prepaid/f2g/images/iconMestro.png'; break
          case 'dinersclub' : return '/ext_files/prepaid/f2g/images/iconDinersclub.png'; break
          case 'americanexpress' : return '/ext_files/prepaid/f2g/images/iconAmex.png'; break
          default : return ''; break;
        }  
      } else {
        return null;
      }
    },
    applicationName() {
      return this.$store.state.applicationName;
    },
    getUserProfileAndTariffsObject() {
      return this.$store.state.userProfileAndTariffsObject;
    },
    getCardAndRecurringInfoObject() {
      return this.$store.state.cardAndRecurringInfoObject;
    },
    token() {
      return this.$store.state.token;
    },
    areInputsDisabled() {
      return this.hasSavedCard && this.savedCard.recurringInfos.length > 0 && !this.isScheduleEditable;
    },
    hasEnabledReccuring() {
      return this.hasSavedCard && this.savedCard.recurringInfos.length > 0;
    },
    minTopUp() {
      if (this.$store.state.userProfileAndTariffsObject.errorCode === "OK") {
        return this.$store.state.userProfileAndTariffsObject
          .prepaidTariffTopUpInfo.resultJsonObject.prepaidTariff.minTopUp;
      } else {
        return 0;
      }
    },
    maxTopUp() {
      if (this.$store.state.userProfileAndTariffsObject.errorCode === "OK") {
        return this.$store.state.userProfileAndTariffsObject
          .prepaidTariffTopUpInfo.resultJsonObject.prepaidTariff.maxTopUp;
      } else {
        return 0;
      }
    },
  },
  watch: {

  },
  created(){
    let self = this;

    /************************
     *** WCS service call ***
     ************************/

    let configWCS = {
      sessionKey: "wcs_topup_auto_recharge",
      axiosConfig: {
      method: "get",
        url: '/gr/f2g/vueContentService/',
        params: {
          ciKey: 'myf2gtopupautorecharge',
          locale: self.locale
        }
      }
    }

    this.fetchDataFromWCS(configWCS)
        .then(response => {
          console.log(JSON.stringify(response))
          self.content = response;
          self.getCardAndRecurringInfoService();
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          console.log("finally");
        });

    document.body.classList.add("opened-overlay");

    
  },
  mounted() {
    
  },
  destroyed(){
    document.body.classList.remove("opened-overlay");
  },
  watch: {
    isComponentLoaded() {
      if (this.isComponentLoaded) {
        var self = this;
        this.$nextTick(function(){
          self.bindMarkupJS();
        })
      }
    }
  },
  methods: {
    closeModal() {
      this.$store.commit("showAutoRechargeModal", false);
    },
    handleCTA() {
      if (this.hasSavedCard) {
        if (this.savedCard.recurringInfos.length > 0) {
          if (this.isScheduleEditable) {
            this.updateReccuringPayment();
          } else {
            this.isScheduleEditable = true;
          }
          
        } else {
          this.initiateReccuringPayment();
        }
      } else {
        this.initiateReccuringPayment(); 
      }
    },
    handleDeletePayment() {
      this.showDeletePaymentMessage = !this.showDeletePaymentMessage;
    },
    getSelectedRecurringDate(){

        console.log("getSelectedRecurringDate called!")
        var sel = document.getElementsByTagName("select")[0];
        this.recurringDate = sel.options[sel.selectedIndex].value;
    },
    getCardAndRecurringInfoService() {

      var getCardsAndRecurringInfoResponse = sessionStorage.getItem("getCardAndRecurringInfo_" + "F2G_" + this.token);
      var self = this;

      if (getCardsAndRecurringInfoResponse == null) {
        this.$store.commit("showLoader");

        this.axios({
          method: "post",
          url: "/epayments/getCardAndRecurringInfo",
          data: {
            applicationName: this.applicationName,
            referrer: "localhost",
            type: this.getUserProfileAndTariffsObject.type,
            externalToken: this.token,
            msisdn: this.getUserProfileAndTariffsObject.msisdn,
            msisdnActivationDate: this.getUserProfileAndTariffsObject.activationDate
          }
        })
          .then(response => {
            console.log("getCardAndRecurringInfo response: " +JSON.stringify(response.data));

            if (response.data.result == "OK") {
              sessionStorage.setItem("getCardAndRecurringInfo_" + "F2G_" + self.token,JSON.stringify(response.data));
              self.$store.commit("setCardAndRecurringInfo", response.data);
              self.$store.commit("hideLoader");

              
              if (response.data.cardList.length > 0) {
                if (response.data.cardList[0].recurringInfos.length > 0) {
                  self.hasScheduledPayment = true;
                  self.amount = response.data.cardList[0].recurringInfos[0].recurringAmount;
                  self.recurringDate = response.data.cardList[0].recurringInfos[0].recurringDate;
                }
              }

              self.isComponentLoaded = true;

            } else {
              console.log("error in getCardAndRecurringInfo");
              self.$store.commit("hideLoader");
              self.$store.commit("showErrorComponent", true);
            }
          })
          .catch(error => {
            console.error("getCardAndRecurringInfo responded with error: " + error);
            self.$store.commit("hideLoader");
            self.$store.commit("showErrorComponent", true);
          });
      } else {
        this.$store.commit("setCardAndRecurringInfo",JSON.parse(getCardsAndRecurringInfoResponse));
        this.isComponentLoaded = true;
        if (this.hasSavedCard) {
          if (this.hasSavedCard.recurringInfos.length > 0) {
            this.amount = this.hasSavedCard.recurringInfos[0].recurringAmount;
            this.recurringDate = this.hasSavedCard.recurringInfos[0].recurringDate;
          }
        }
      }
    },
    deleteCard() {
      /* This method is available when saved card exists */

      var self = this;
      self.$store.commit("showLoader");
      this.axios({
        method: "post",
        url: "/epayments/deleteCard",
        data: {
          guid: 'unknown',
          datacashReference: this.savedCard.datacacheReference,
          msisdn: this.getUserProfileAndTariffsObject.msisdn,
          msisdnActivationDate: this.getUserProfileAndTariffsObject.activationDate
        }
      })
      .then(response => {
        console.log("deleteCard response: " +JSON.stringify(response.data));


        if (response.data.result == "OK") {
          var cardAndRecurringInfoObject = {"result":"OK","merchantRef":self.getCardAndRecurringInfoObject.merchantRef,"secToken":self.getCardAndRecurringInfoObject.secToken,"transactionCode":self.getCardAndRecurringInfoObject.transactionCode,"cardList":[], "isSuccess": true};
          self.$store.commit("setCardAndRecurringInfo", cardAndRecurringInfoObject);
          sessionStorage.setItem('getCardAndRecurringInfo_' + "F2G_" + self.token, JSON.stringify(cardAndRecurringInfoObject));

          self.$store.commit("hideLoader");

        } else {
          console.log("error in deleteCard");
          self.$store.commit("hideLoader");
          self.$store.commit("showErrorComponent", true);
        }
      })
      .catch(error => {
        console.error("deleteCard responded with error: " + error);
        self.$store.commit("hideLoader");
        self.$store.commit("showErrorComponent", true);
      });
    },
    deleteRecurringPayment() {
      /* This method is available when saved card exists and there is a reccuring option */
      this.$store.commit("showDisableAutoRechargePrompt", true);
    },
    updateReccuringPayment() {
      /* This method is called when saved card and reccuring exists*/

      if (this.areInputsValid) {
        var self = this;

        self.$store.commit("showLoader");
        this.axios({
          method: "post",
          url: "/epayments/updateRecurringPayment",
          data: {
            recurringToken: this.savedCard.recurringInfos[0].recurringToken,
            amount: this.amount,
            recurringDate: this.recurringDate
          }
        })
        .then(response => {
          console.log("updateRecurringPayment response: " +JSON.stringify(response.data));

          if (response.data.result == "OK") {

            var cardAndRecurringInfoObject = {"result":"OK","merchantRef":self.getCardAndRecurringInfoObject.merchantRef,"secToken":self.getCardAndRecurringInfoObject.secToken,"transactionCode":self.getCardAndRecurringInfoObject.transactionCode,"cardList":[{"brand":self.savedCard.brand,"pan":self.savedCard.pan,"datacacheReference":self.savedCard.datacacheReference,"token":self.savedCard.token,"supportsInstalments":self.savedCard.supportsInstalments,"expiryDate":self.savedCard.expiryDate,"recurringInfos":[{"recurringToken":self.savedCard.recurringInfos[0].recurringToken,"recurringDate":self.recurringDate,"recurringAmount":self.amount}]}], "isSuccess": true};
            self.$store.commit("setCardAndRecurringInfo", cardAndRecurringInfoObject);
            sessionStorage.setItem('getCardAndRecurringInfo_' + "F2G_" + self.token, JSON.stringify(cardAndRecurringInfoObject));
            
            /* HANDLE SUCCESS CASE*/
            self.$store.commit("hideLoader");

            self.$store.commit("updateRecurringActionMsisdn",self.getUserProfileAndTariffsObject.msisdn);
            self.$store.commit("updateRecurringActionAmount", self.amount);
            self.$store.commit("updateRecurringActionDate", self.recurringDate);
            self.$store.commit("updateRecurringActionTransactionCode",self.getCardAndRecurringInfoObject.transactionCode);

            self.$store.commit("isUpdateReccuringAction",true);

            self.$store.commit("showSuccessComponent",true);

          } else {
            console.log("error in updateRecurringPayment");
            self.$store.commit("hideLoader");
            self.$store.commit("showErrorComponent", true);
          }
        })
        .catch(error => {
          console.error("updateRecurringPayment responded with error: " + error);
          self.$store.commit("hideLoader");
          self.$store.commit("showErrorComponent", true);
        });
      }
    },
    initiateReccuringPayment() {
      /* This method is called when there is no saved card or saved recurring */

      if (this.areInputsValid) {
        var self = this;

        self.$store.commit("showLoader");
        this.axios({
          method: "post",
          url: "/epayments/initiatePaymentNative",
          data: {
            applicationName: this.applicationName,
            merchantRef: this.getCardAndRecurringInfoObject.merchantRef,
            msisdnActivationDate: this.getUserProfileAndTariffsObject.activationDate,
            transactionCode: this.getCardAndRecurringInfoObject.transactionCode,
            secToken: this.getCardAndRecurringInfoObject.secToken,
            amount: this.amount,
            customerCode: "unknownCustomerCode",
            customerName: "unknownCustomerName",
            invoiceNumber: null,
            callbackURI: null,
            hostName: "212.205.16.1",
            locale: this.language,
            msisdn: this.getUserProfileAndTariffsObject.msisdn,
            postalCode: null,
            sendCallback: false,
            taxNumber: 'unknownTaxNumber',
            transferMsisdn: this.getUserProfileAndTariffsObject.msisdn,
            twoStagesFlow: false,
            currency: "EUR",
            userName: 'unknown',
            saveCard: true,
            savedCard: this.hasDatacacheReference,
            useSavedCard: this.hasSavedCard,
            minNumberOfInstalments: 0,
            maxNumberOfInstalments: 0,
            numberOfInstalments: 0,
            recurringType: 'SETUP',
            recurringDate: this.recurringDate,
            recurringThreshold: '',
            recurringService: '9999',
            recurringAsset: this.getUserProfileAndTariffsObject.msisdn,
            requestInvoice: true,
            paymentMethod: 'card',
            email: this.getUserProfileAndTariffsObject.email,
            browser: this.determineBrowser(),
            screenWidth : window.screen.width,
            screenHeight: window.screen.height
          }
        })
        .then(response => {
          console.log("initiatePaymentNative response: " +JSON.stringify(response.data));

          if (response.data.result == "OK") {
            
            //clear service response from session storage
              sessionStorage.removeItem('getUserProfileAndTariffs_' + "F2G_" + this.token);
              sessionStorage.removeItem('getCardAndRecurringInfo_' + "F2G_" + this.token);
            
              //Add a key to session storage to know if we have returned from bank
              sessionStorage.setItem("activeFlow_" + "F2G_" + self.token,"false");

            if(self.hasSavedCard){
              window.location.href = "/epayments/beginPayment?merchantRef=" + self.getCardAndRecurringInfoObject.merchantRef + "&secToken=" + self.getCardAndRecurringInfoObject.secToken;
            }else{
              window.location.href = "/"+ self.lang +"/f2g/nbg-payments/?mid=" + response.data.merchantId + "&amount=" + "0,01" + "&sessionid=" + response.data.masterCardSessionId + "&applicationname=" + self.applicationName + "&merchantref=" +  self.getCardAndRecurringInfoObject.merchantRef+ "&sectoken=" + self.getCardAndRecurringInfoObject.secToken + "&transactioncode=" + self.getCardAndRecurringInfoObject.transactionCode + "&recurring="+true + "&anonymous=" + false;
            }
            
            self.$store.commit("hideLoader");

          } else {

            if (response.data.fault.faultCode == 19){
              var faultDescription = response.data.fault.faultDescription;
              self.$store.commit("setFaultDescription", faultDescription);
            }else{
              console.log("initiatePaymentNative responded: " + response.data.result);
            }

            console.log("error in initiatePaymentNative");
            self.$store.commit("hideLoader");
            self.$store.commit("showErrorComponent", true);

          }
        })
        .catch(error => {
          console.error("initiatePaymentNative responded with error: " + error);
          self.$store.commit("hideLoader");
          self.$store.commit("showErrorComponent", true);
        });
      }
    },
    bindMarkupJS() {

        var self = this;
  
        
        /* INIT DROPDOWN */
        var x, i, j, selElmnt, a, b, c;
        /*look for any elements with the class "custom-select":*/
        x = document.getElementsByClassName("custom-select");
        for (i = 0; i < x.length; i++) {
          selElmnt = x[i].getElementsByTagName("select")[0];
          /*for each element, create a new DIV that will act as the selected item:*/
          a = document.createElement("DIV");
          a.setAttribute("class", "select-selected");
          
          if(self.recurringDate != '') {
            a.innerHTML = self.recurringDate;
          } else {
            a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
          }
          
          x[i].appendChild(a);
          /*for each element, create a new DIV that will contain the option list:*/
          b = document.createElement("DIV");
          b.setAttribute("class", "select-items select-hide");
          for (j = 1; j < selElmnt.length; j++) {
            /*for each option in the original select element,
            create a new DIV that will act as an option item:*/
            c = document.createElement("DIV");
            c.innerHTML = selElmnt.options[j].innerHTML;
            c.addEventListener("click", function(e) {
                /*when an item is clicked, update the original select box,
                and the selected item:*/
                var y, i, k, s, h;
                s = this.parentNode.parentNode.getElementsByTagName("select")[0];
                h = this.parentNode.previousSibling;
                for (i = 0; i < s.length; i++) {
                  if (s.options[i].innerHTML == this.innerHTML) {
                    s.selectedIndex = i;
                    self.recurringDate = i.toString();
                    self.$forceUpdate();
                    h.innerHTML = this.innerHTML;
                    y = this.parentNode.getElementsByClassName("same-as-selected");
                    for (k = 0; k < y.length; k++) {
                      y[k].removeAttribute("class");
                    }
                    this.setAttribute("class", "same-as-selected");
                    break;
                  }
                }
                h.click();
            });
            b.appendChild(c);
          }
          x[i].appendChild(b);
          a.addEventListener("click", function(e) {
              /*when the select box is clicked, close any other select boxes,
              and open/close the current select box:*/
              e.stopPropagation();
              closeAllSelect(this);
              this.nextSibling.classList.toggle("select-hide");
              this.classList.toggle("select-arrow-active");
            });
        }
        function closeAllSelect(elmnt) {
          /*a function that will close all select boxes in the document,
          except the current select box:*/
          var x, y, i, arrNo = [];
          x = document.getElementsByClassName("select-items");
          y = document.getElementsByClassName("select-selected");
          for (i = 0; i < y.length; i++) {
            if (elmnt == y[i]) {
              arrNo.push(i)
            } else {
              y[i].classList.remove("select-arrow-active");
            }
          }
          for (i = 0; i < x.length; i++) {
            if (arrNo.indexOf(i)) {
              x[i].classList.add("select-hide");
            }
          }
        }
        /*if the user clicks anywhere outside the select box,
        then close all select boxes:*/
        document.addEventListener("click", closeAllSelect);

    },
    determineBrowser() {
      var nAgt = navigator.userAgent ? navigator.userAgent : "";
      var browserName  = navigator.appName ? navigator.appName : "";
      var fullVersion  = ''+parseFloat(navigator.appVersion); 
      var majorVersion = parseInt(navigator.appVersion,10);
      var nameOffset,verOffset,ix;

      // In Opera, the true version is after "Opera" or after "Version"
      if ((verOffset=nAgt.indexOf("Opera"))!=-1) {
        browserName = "Opera";
        fullVersion = nAgt.substring(verOffset+6);
        if ((verOffset=nAgt.indexOf("Version"))!=-1) 
          fullVersion = nAgt.substring(verOffset+8);
      }
      // In Opera, the true version might also be after "OPR" or after "Version"
      else if ((verOffset=nAgt.indexOf("OPR"))!=-1) {
        browserName = "Opera";
        fullVersion = nAgt.substring(verOffset+4);
      }
      // In MSIE, the true version is after "MSIE" in userAgent
      else if ((verOffset=nAgt.indexOf("MSIE"))!=-1) {
        browserName = "Internet Explorer";
        fullVersion = nAgt.substring(verOffset+5);
      }
      // In MSIE 11, the true version is rv "Trident" in userAgent
      else if ((verOffset=nAgt.indexOf("Trident/7.0"))!=-1) {
        browserName = "Internet Explorer";
        fullVersion = "11.0";
      }
      //start of handling all Edge cases
      else if ((verOffset=nAgt.indexOf("Edg"))!=-1) {
        browserName = "Edge";
        fullVersion = nAgt.substring(verOffset+4);
      }
      else if ((verOffset=nAgt.indexOf("Edge"))!=-1) {
        browserName = "Edge";
        fullVersion = nAgt.substring(verOffset+5);
      }
      else if ((verOffset=nAgt.indexOf("EdgA"))!=-1) {
        browserName = "Edge";
        fullVersion = nAgt.substring(verOffset+5);
      }
      else if ((verOffset=nAgt.indexOf("EdgiOS"))!=-1) {
        browserName = "Edge";
        fullVersion = nAgt.substring(verOffset+7);
      }
      // In Chrome, the true version is after "Chrome" 
      else if ((verOffset=nAgt.indexOf("Chrome"))!=-1) {
        browserName = "Chrome";
        fullVersion = nAgt.substring(verOffset+7);
      }
      // In Safari, the true version is after "Safari" or after "Version" 
      else if ((verOffset=nAgt.indexOf("Safari"))!=-1) {
        browserName = "Safari";
        fullVersion = nAgt.substring(verOffset+7);
        if ((verOffset=nAgt.indexOf("Version"))!=-1) 
          fullVersion = nAgt.substring(verOffset+8);
      }
      // In Firefox, the true version is after "Firefox" 
      else if ((verOffset=nAgt.indexOf("Firefox"))!=-1) {
          browserName = "Firefox";
          fullVersion = nAgt.substring(verOffset+8);
      }
      // In most other browsers, "name/version" is at the end of userAgent 
      else if ( (nameOffset=nAgt.lastIndexOf(' ')+1) < (verOffset=nAgt.lastIndexOf('/')) ) {
          browserName = nAgt.substring(nameOffset,verOffset);
          fullVersion = nAgt.substring(verOffset+1);
          if (browserName.toLowerCase()==browserName.toUpperCase()) {
            browserName = navigator.appName;
          }
      }
      // trim the fullVersion string at semicolon/space if present
      if ((ix=fullVersion.indexOf(";"))!=-1)
          fullVersion=fullVersion.substring(0,ix);
      if ((ix=fullVersion.indexOf(" "))!=-1)
          fullVersion=fullVersion.substring(0,ix);

      majorVersion = parseInt(''+fullVersion,10);
      if (isNaN(majorVersion)) {
          fullVersion  = ''+parseFloat(navigator.appVersion); 
          majorVersion = parseInt(navigator.appVersion,10);
      }


      return browserName + ' ' + fullVersion;
    }
  }
  
}
</script>